import {
    PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER
  } from './constants'
  
  export function clearBonificacionVendedor() {
    return (dispatch) => {

      dispatch({
        type: PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER,
        data: {
          special_discount: null
        }
      })
    }
  }  
  
  export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER) {
            return {
                ...state,
                ...action.data,
            }
    }
    else {
            return state
    }
  }
  